import React, { useMemo, useState } from "react"
import { useViewport } from 'components/general/useViewPort'
import MirsTable from "components/general/table/Table"
import { Accordion } from 'react-bootstrap'
import { useUrlFriendlyToParameters, useNavigateTo } from 'helpers/urlFriendly';
import { getLevelRSC, getLongEventRSC } from "helpers/rsc"
import Noc from "components/presentation/Noc";
import Label from "components/general/Label";
import Competitor from "components/presentation/Competitor";
import Discipline from "components/presentation/Discipline";
import Medal from "components/presentation/Medal";

const getConfiguration = (breakPoint) => {
  const isMobile = (breakPoint === "sm" || breakPoint === "xs")
  let configuration = {
    columns: [],
    sortBy: [],
    disableSort: false
  };
  configuration.sortBy = [{ id: "Rank", desc: false }]
  configuration.columns = isMobile ? TableColumnsSM() : TableColumns()
  return configuration;
};


const MultiMedallistTable = ({ data }) => {
  const { breakPoint } = useViewport();
  const config = useMemo(() => getConfiguration(breakPoint), [breakPoint]);
  const [paramsUrl, setParamsUrl] = useState({});
  const [shouldNavigate, setShouldNavigate] = useState(false);
  useNavigateTo(paramsUrl, shouldNavigate, setShouldNavigate, 'results')

  //Prepare URL to navigate
  const params = useUrlFriendlyToParameters()
  let paramsURL = { ...params }

  const handleClick = (props) => {
    const rsc = props?.eventUnit?.code;
    if (getLevelRSC(paramsURL["mirs_rsc"]) === "EVENT") {
      paramsURL["mirs_event_rsc"] = rsc
      paramsURL["mirs_rsc"] = undefined
    } else {
      //Phase or unit
      paramsURL["mirs_event_rsc"] = getLongEventRSC(rsc)
      paramsURL["mirs_rsc"] = rsc
    }
    setParamsUrl(paramsURL);
  };

  return (
    <MirsTable
      className="table-schedule"
      data={data}
      columns={config.columns}
      keyRow='participant-code'
      initialSortBy={config.sortBy}
      rowOnClick={true}
      rowClickHandler={handleClick}
      id={`mirs-table-medallists`}
      showPagination={true}
    // pageSizeCustom={10}
    />
  )
}
export default MultiMedallistTable;



function TableColumns() {
  return (
    [
      ColumnRank({}),
      ColumnCompetitor({}),
      ColumnSport({}),
      ColumnEvent({}),
      ColumnMedal({}),
      ColumnTotal({}),
    ]
  )
}

function TableColumnsSM() {
  return (
    [
      ColumnRank({}),
      ColumnCompetitor({}),
      ColumnSport({}),
      ColumnEvent({}),
      ColumnMedal({}),
      ColumnTotal({}),
    ]
  )
}

function ColumnRank() {
  return (
    {
      Header: <Label data={"HeaderRank"} />,
      className: "text-center",
      headerClassName: "text-center w-5",
      accessor: 'rank',
      disableSortBy: false,
      // remove: true,
      id: 'Rank',
      Cell: (props) => {
        const row = props.cell.row.original;
        return row.rank
      }
    }
  )
}

function ColumnTotal() {
  return (
    {
      Header: <Label data={"HeaderTotal"} />,
      className: "text-center",
      headerClassName: "text-center w-5",
      accessor: 'medals.total',
      disableSortBy: false,
      id: 'Total',
      Cell: (props) => {
        const row = props.cell.row.original;
        return row.medals.total;
      }
    }
  )
}

export function ColumnCompetitor({
  label = "LabelName",
  disableSort = false
}) {
  return (
    {
      Header: <Label data={label} legendFixed={true} />,
      accessor: 'athlete.TVName',
      disableSortBy: true,
      id: 'Name',
      Cell: (props) => {
        const row = props.cell.row.original;
        return (
          <div className="multimedallist-competitor">
            <Competitor {...row?.athlete} alwaysNoc={true} hideNoc={false} hidePicture={false} noLink={false} noc={row?.athlete?.organisation?.code} />
          </div>
        )
      }
    }
  )
}

function ColumnSport({
  label = "HeaderSport"
}) {
  return (
    {
      Header: <Label data={label} legendFixed={true} />,
      disableSortBy: true,
      id: 'Sport',
      Cell: (props) => {
        const row = props.cell.row.original
        return (
          row?.events.map(e => (<Discipline code={e?.discipline.code} description={e?.discipline?.description} key={`${e?.discipline.code}-${e?.eventUnit.code}`} />
          ))
        )
      }
    }
  )
}


function ColumnEvent({
  label = "HeaderEvent"
}) {
  return (
    {
      Header: <Label data={label} legendFixed={true} />,
      disableSortBy: true,
      id: 'Event',
      Cell: (props) => {
        const row = props.cell.row.original
        return (
          row?.events.map(e => (<div key={`${e?.discipline.code}-${e?.eventUnit.code}`}>{e.eventUnit.longDescription}</div>
          ))
        )
      }
    }
  )
}


function ColumnMedal({
  label = "HeaderMedal"
}) {
  return (
    {
      Header: <Label data={label} legendFixed={true} />,
      disableSortBy: true,
      id: 'Medal',
      Cell: (props) => {
        const row = props.cell.row.original
        return (
          row?.events.map(e => (<div key={`${e?.medal_type}-${e?.eventUnit.code}`}> <Medal code={e?.medal_type} /></div>
          ))
        )
      }
    }
  )
}


